 import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  //mode:'history',
  routes: [
      {
        path: '/',
        //component:Z_home,
        component: resolve=>require(['@/pages/Z_home'],resolve),
        /*meta:{
          keepAlive: true  // 需要缓存
        }*/
      },{
      path: '/z_home_b',
      component: resolve=>require(['@/pages/Z_home_b'],resolve),
      //component:Z_home_b,
      meta:{
        keepAlive: true  // 需要缓存
      }
      },
    {
      path: '/t',
      //component: SmsVerification
      component: resolve=>require(['@/pages/t'],resolve),
    },{
        path:'/updateCarInfo',
        //component: UpdateCarInfo
        component: resolve=>require(['@/pages/UpdateCarInfo'],resolve),
    },{
      path:'/myMessage',
      //component: MyMessage
      component: resolve=>require(['@/pages/MyMessage'],resolve),
    },{
        path:'/myListChatMsg',
        //component:MychatMsg
        component: resolve=>require(['@/pages/MyListChatMsg'],resolve),
    },{
       path:'/useProtocol',
       //component:UseProtocol
      component: resolve=>require(['@/pages/UseProtocol'],resolve),
    },{
        path:'/privacyAgreement',
        //component:PrivacyAgreement
      component: resolve=>require(['@/pages/PrivacyAgreement'],resolve),
    },{
        path:'/brand',
        //component:Brand
        component: resolve=>require(['@/pages/Brand'],resolve),
    },{
        path:'/testAudio',
        //component:TestAudio
        component: resolve=>require(['@/pages/TestAudio'],resolve),
    },{
        path:'/lookSellCarInfo',
        component:resolve=>require(['@/pages/LookSellCarInfo'],resolve)
    },{
        path:'/loadMore',
        component:resolve=>require(['@/pages/LoadMore'],resolve)
    },{
      path:'/about',
      component:resolve=>require(['@/pages/About'],resolve)
    },{
        path:'/updateNickName',
        component:resolve=>require(['@/pages/UpdateNickName'],resolve)
    },{
        path:'/genderPage',
        component:resolve=>require(['@/pages/Gender'],resolve)
    },{
      path:'/updateTel',
      component:resolve=>require(['@/pages/UpdateTel'],resolve)
    },{
        path:'/z_updatePassword',
        component:resolve=>require(['@/pages/Z_updatePassword'],resolve)
    },{
        path:'/updatePwByPhone',
        component:resolve=>require(['@/pages/UpdatePwByPhone'],resolve)
    },{
      path:'/systemMs',
      component:resolve=>require(['@/pages/SystemMs'],resolve)
    },{
        path:'/uinfo',
		    name:'Uinfo',
        component:resolve=>require(['@/pages/UInfo'],resolve)
    },{
      path:'/z_login',
      component:resolve=>require(['@/pages/Z_login'],resolve)
    },{
      path:'/z_phoneLogin',
      component:resolve=>require(['@/pages/Z_phoneLogin'],resolve)
    },{
      path:'/z_register',
      component:resolve=>require(['@/pages/Z_register'],resolve)
    },{
      path:'/z_changeUserInfo',
      //component:ChangeUserInfo
      component: resolve=>require(['@/pages/ChangeUserInfo'],resolve),
    },{
      path:'/z_verification',
      name:'Z_verification',
      component:resolve=>require(['@/pages/Z_verification'],resolve)
    },{
      path:'/z_home',
      component:resolve=>require(['@/pages/Z_home'],resolve),
      meta:{
        keepAlive: true  // 需要缓存
      }
    },{
      path:'/z_home_map',
      component:resolve=>require(['@/pages/Z_home_map'],resolve)
    },{
      path:'/z_typelist',
      component:resolve=>require(['@/pages/Z_typelist'],resolve),
      meta:{
        keepAlive: true  // 需要缓存
      }
    },{
      path:'/jd_goodlist',
      component:resolve=>require(['@/pages/jd_goodlist'],resolve),
      meta:{
        keepAlive: true  // 需要缓存
      }
    },{
      path:'/jd_goods',
      component:resolve=>require(['@/pages/jd_goods'],resolve),
      meta:{
        keepAlive: true  // 需要缓存
      }
    },{
      path:'/z_find',
      component:resolve=>require(['@/pages/Z_find'],resolve),
      meta:{
        keepAlive: true  // 需要缓存
      }
    },{
      path:'/z_find_hot',
      component:resolve=>require(['@/pages/Z_find_hot'],resolve),
      meta:{
        keepAlive: true  // 需要缓存
      }
    },{
      path:'/z_myfindreply',
      component:resolve=>require(['@/pages/Z_myfindreply'],resolve),
      meta:{
        keepAlive: true  // 需要缓存
      }
    },{
      path:'/z_myfinddiscuss',
      component:resolve=>require(['@/pages/Z_myfinddiscuss'],resolve),
      meta:{
        keepAlive: true  // 需要缓存
      }
    },{
      path:'/z_myfind_b',
      component:resolve=>require(['@/pages/Z_myfind_b'],resolve)
    },{
      path:'/z_my',
      component:resolve=>require(['@/pages/Z_my'],resolve)
    },{
      path:'/z_houseDetail',
      component:resolve=>require(['@/pages/Z_houseDetail'],resolve)
    },{
      path:'/z_myhouse',
      component:resolve=>require(['@/pages/Z_myhouse'],resolve),
      meta:{
        keepAlive: true  // 需要缓存
      }
    },{
      path:'/z_myfind',
      component:resolve=>require(['@/pages/Z_myfind'],resolve),
      meta:{
        keepAlive: true  // 需要缓存
      }
    },{
      path:'/z_myfindcoll',
      component:resolve=>require(['@/pages/Z_myfindcoll'],resolve),
      meta:{
        keepAlive: true  // 需要缓存
      }
    },{
      path:'/z_myfindcoll_h',
      component:resolve=>require(['@/pages/Z_myfindcoll_h'],resolve),
      meta:{
        keepAlive: true  // 需要缓存
      }
    },{
      path:'/z_feedback',
      component:resolve=>require(['@/pages/Z_feedback'],resolve)
    },{
      path:'/z_home_map',
      component:resolve=>require(['@/pages/Z_home_map'],resolve)
    },{
      path:'/z_bhouse',
      component:resolve=>require(['@/pages/Z_bhouse'],resolve)
    },{
      path:'/z_myhouse_y',
      component:resolve=>require(['@/pages/Z_myhouse_y'],resolve),
      meta:{
        keepAlive: true  // 需要缓存
      }
    },{
      path:'/z_bhouse_update',
      component:resolve=>require(['@/pages/Z_bhouse_update'],resolve)
    },{
      path:'/z_bfind',
      component:resolve=>require(['@/pages/Z_bfind'],resolve)
    },{
      path:'/z_comfirdPassword',
      name:'Z_comfirdPassword',
      component:resolve=>require(['@/pages/Z_comfirdPassword'],resolve)
    }/*,{
      path:'/test',
      component:resolve=>require(['@/pages/Test'],resolve)
    }*/,{
      path:'/t2',
      component:resolve=>require(['@/pages/t2'],resolve)
    },{
      path:'/t5',
      component:resolve=>require(['@/pages/t5'],resolve)
    },{
      path:'/z_city',
      component:resolve=>require(['@/pages/Z_city'],resolve)
    },{
      path:'/z_findComment',
      component:resolve=>require(['@/pages/Z_findComment'],resolve)
    },{
      path:'/z_setting',
      //component:Setting
      component: resolve=>require(['@/pages/Z_setting'],resolve),
    },{
      path: '/chat',
      //component: Chat
      component: resolve=>require(['@/pages/Chat'],resolve)
    },{
      path: '/chatMsg',
      //component: Chat
      component: resolve=>require(['@/pages/ChatMsg'],resolve)
    },{
      path: '/z_clentGetContact/:id',
      //component: Chat
      component: resolve=>require(['@/pages/Z_clentGetContact'],resolve)
    },{
      path:'/pc/lineup',
      component:resolve=>require(['@/pages/Lineup'],resolve)
    },{
      path:'/pc/shoplineup',
      component:resolve=>require(['@/pages/shopLineup'],resolve)
    }
    ]

})



// WEBPACK FOOTER //
// ./src/router/index.js